import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "credits" }, "© Marianne Westenthanner 2022")
], -1)

import { useStore } from 'vuex';
import { onBeforeMount } from 'vue';
import HeaderBlock from './components/HeaderBlock.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const store = useStore()

// Fetch recipes from backend and store
onBeforeMount(async () => {

      const recipeResp = await fetch('https://notion-cooks.netlify.app/.netlify/functions/api/recipes');
      const recipeData = await recipeResp.json();

      const collectionResp = await fetch('https://notion-cooks.netlify.app/.netlify/functions/api/collections');
      const collectionData = await collectionResp.json();
      
      store.commit('setRecipeList', recipeData);
      store.commit('setCollectionList', collectionData);
      store.commit('setTagListFromRecipes');

    });




return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderBlock),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _hoisted_1
  ], 64))
}
}

})